import { render, staticRenderFns } from "./RaporAiSihirbazi.vue?vue&type=template&id=0eda746b&scoped=true"
import script from "./RaporAiSihirbazi.vue?vue&type=script&lang=ts"
export * from "./RaporAiSihirbazi.vue?vue&type=script&lang=ts"
import style0 from "./RaporAiSihirbazi.vue?vue&type=style&index=0&id=0eda746b&prod&scoped=true&lang=css"
import style1 from "./RaporAiSihirbazi.vue?vue&type=style&index=1&id=0eda746b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eda746b",
  null
  
)

export default component.exports